import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { Messages } from '../../codegen/Localize';
import { showActionableToast } from '../../common/react/components/ActionableMessage';
import { L10n } from '../../ts/L10n/L10n';
import { ViewRecommendations } from '../services/ViewRecommendations';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ToastType } from '../../ts/services/ToasterService';
import { HideRecommendation, UndoHideRecommendation } from '../../app/actions/AppActionTypes';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { HideRecommendationAction, recommendationHidden, recommendationUnhidden, undoHideRecommendation as undoHideRecommendationAction, UndoHideRecommendationAction } from '../actions/HideRecommendationAction';
import { getAppStore } from '../../app/AppStore';

export function* hideRecommendation(action: HideRecommendationAction) {
  try {
    const resp = yield call(hideRecCall, action);
    if (resp.errors && resp.errors.length > 0) {
      throw 'rec dismissal failed with unexpected parameters';
    }

    yield put(recommendationHidden(action.contentId, action.contentType));
    showUndoHideRecommendationToast(action);

  } catch(e) {
    yield put(requestFailed(e, Messages.recommendationsError()));
  }
}

export function hideRecCall(action: HideRecommendationAction): Promise<IResult> {
  return ViewRecommendations.hideRecommendation(action.contentType, action.contentId);
}

export function* undoHideRecommendation(action: UndoHideRecommendationAction) {
  try {
    const resp = yield call(undoHideRecCall, action);
    if (resp.errors && resp.errors.length > 0) {
      throw 'rec undo dismissal failed with unexpected parameters';
    }

    yield put(recommendationUnhidden(action.contentId, action.contentType));

  } catch(e) {
    yield put(requestFailed(e, Messages.recommendationsError()));
  }
}

export function undoHideRecCall(action: UndoHideRecommendationAction): Promise<IResult> {
  return ViewRecommendations.undoHideRecommendation(action.contentType, action.contentId);
}

export function* rootHiddenRecsSaga(): SagaIterator {
  yield takeEvery(HideRecommendation, hideRecommendation);
  yield takeEvery(UndoHideRecommendation, undoHideRecommendation);
}

const maxCharactersForName = 22;

function showUndoHideRecommendationToast(action: HideRecommendationAction) {
  showActionableToast({
    testId: 'undo-hide-rec',
    message: Messages.recommendationHidden({NAME: L10n.elideIfLong(action.contentName, maxCharactersForName)}),
    actionMessage: Messages.recommendationHiddenUndo(),
    action: () => getAppStore().dispatch(undoHideRecommendationAction(action.contentId, action.contentType))
  }, ToastType.Success);
}
